export interface MenuBadge {
  text: string;
  cssClass: string;
}

export interface MenuItem {
  id: string;
  label: string;
  route?: string;
  badge?: MenuBadge;
  children?: MenuItem[];
  enConstruccion?: boolean;
}

export interface MenuSection {
  id: string;
  icon: string;
  label: string;
  badge?: MenuBadge;
  children: MenuItem[];
  enConstruccion?: boolean;
}

export const MENU_DATA: MenuSection[] = [
  // ─────────────────────────────────────────
  //  INICIO – Accesos directos sin submenú
  // ─────────────────────────────────────────
  {
    id: 'dashboard',
    icon: 'ri-dashboard-line',
    label: 'Dashboard',
    children: [
      { id: 'dashboard', label: 'Dashboard', route: '/', enConstruccion: false },
    ]
  },

  {
    id: 'inicio',
    icon: 'ri-home-line',
    label: 'Inicio',
    children: [
      { id: 'plantillas', label: 'Plantillas', route: '/plantilla/plantilla-personal', enConstruccion: false },
      { id: 'posiciones', label: 'Posiciones', route: '/posiciones', enConstruccion: false },
      { id: 'extras', label: 'Extras', route: '/plantilla/posiciones-extras', enConstruccion: false },
      { id: 'empleado', label: 'Empleados', route: '/empleados/directorio', enConstruccion: false },
      { id: 'organigrama', label: 'Organigrama', route: '/organizacion/organigrama', enConstruccion: false },
      {
        id: 'mopers',
        label: 'Mopers',
        children: [
          { id: 'mopers-movimientos', label: 'Movimientos del personal', route: '/empleados/movimientos', enConstruccion: false },
          { id: 'mopers-autorizantes', label: 'Autorizantes de MOPER', route: '/empleados/autorizantes-moper', enConstruccion: false },
        ]
      },
      { id: 'convenios', label: 'Convenios', route: '/convenios/convenios', enConstruccion: false },
      { id: 'finiquitos', label: 'Finiquitos', route: '/nomina/finiquitos', enConstruccion: false },
    ]
  },

  // ─────────────────────────────────────────
  //  ORGANIZACIÓN – Catálogos agrupados por tema
  //  (Empresa · Estructura · Puestos · Tiempo · Nómina · Operación)
  // ─────────────────────────────────────────
  {
    id: 'personal',
    icon: 'ri-user-settings-line',
    label: 'Organización',
    children: [
      {
        id: 'org-empresa',
        label: 'Empresa',
        children: [
          { id: 'empresa', label: 'Razon Social', route: '/empresa/empresa', enConstruccion: false },
          { id: 'razon-social', label: 'Sucursales', route: '/empresa/sucursales', enConstruccion: false },
        ]
      },
      {
        id: 'org-estructura',
        label: 'Estructura',
        children: [
          { id: 'area', label: 'Áreas', route: '/catalogos/areas', enConstruccion: false },
          { id: 'division', label: 'Divisiones', route: '/catalogos/divisiones', enConstruccion: false },
          { id: 'departamento', label: 'Departamentos', route: '/catalogos/departamentos', enConstruccion: false },
          { id: 'sub-depto', label: 'Subdepartamentos', route: '/catalogos/subdepartamentos', enConstruccion: false },
          { id: 'centro-costo', label: 'Centros de costo', route: '/catalogos/centros-costo', enConstruccion: false },
          { id: 'ubicacion', label: 'Ubicaciones', route: '/catalogos/ubicaciones', enConstruccion: false },
        ]
      },
      {
        id: 'org-puestos',
        label: 'Puestos y categorías',
        children: [
          { id: 'puesto', label: 'Puestos', route: '/catalogos/puestos', enConstruccion: false },
          { id: 'categoria', label: 'Categorías', route: '/catalogos/categorias', enConstruccion: false },
          { id: 'nivel', label: 'Niveles', route: '/catalogos/niveles', enConstruccion: false },
          { id: 'clasificacion', label: 'Clasificaciones', route: '/catalogos/clasificaciones', enConstruccion: false },
          { id: 'rama', label: 'Ramas', route: '/catalogos/ramas', enConstruccion: false },
        ]
      },
      {
        id: 'org-tiempo',
        label: 'Tiempo y asistencia',
        children: [
          { id: 'rol-turnos', label: 'Roles de turno', route: '/catalogos/roles-turno', enConstruccion: false },
          { id: 'horario-turno', label: 'Horarios', route: '/catalogos/horarios', enConstruccion: false },
          { id: 'dia-festivo', label: 'Días festivos', route: '/catalogos/dias-festivos', enConstruccion: false },
          { id: 'rotacion', label: 'Rotaciones', route: '/catalogos/rotaciones', enConstruccion: false },
          { id: 'reloj', label: 'Relojes', route: '/catalogos/relojes', enConstruccion: false },
          { id: 'ciclo', label: 'Ciclos', route: '/catalogos/ciclos', enConstruccion: false },
        ]
      },
      {
        id: 'org-nomina',
        label: 'Nómina',
        children: [
          { id: 'periodo-pago', label: 'Periodos de pago', route: '/catalogos/periodos-pago', enConstruccion: false },
          { id: 'periodos-nomina', label: 'Periodos de nómina', route: '/nomina/periodos-nomina', enConstruccion: false },
          { id: 'reg-patronal', label: 'Registros patronales', route: '/catalogos/registros-patronales', enConstruccion: false },
          { id: 'prestaciones', label: 'Prestaciones', route: '/catalogos/prestaciones', enConstruccion: false },
        ]
      },
      {
        id: 'org-operacion',
        label: 'Operación',
        children: [
          { id: 'justificacion', label: 'Justificaciones', route: '/catalogos/justificaciones', enConstruccion: false },
          { id: 'paro-tecnico', label: 'Paros técnicos', route: '/catalogos/paros-tecnicos', enConstruccion: false },
          { id: 'causa-bloqueo', label: 'Causas de bloqueo', route: '/catalogos/causas-bloqueo', enConstruccion: false },
          { id: 'mov-historico', label: 'Movimientos de histórico de empleado', route: '/catalogos/mov-historico-empleado', enConstruccion: false },
          { id: 'tareas-cat', label: 'Tareas', route: '/catalogos/tareas', enConstruccion: false },
          { id: 'documentos', label: 'Documentos', route: '/catalogos/documentos-requeridos', enConstruccion: false },
        ]
      },
    ]
  },

  // ─────────────────────────────────────────
  //  ASISTENCIA – Asistencia, Variables, Ausentismo
  // ─────────────────────────────────────────
  {
    id: 'asistencia',
    icon: 'ri-calendar-check-line',
    label: 'Asistencia',
    children: [
      {
        id: 'asistencia-menu',
        label: 'Asistencia',
        children: [
          { id: 'vista-turno', label: 'Vista del turno', route: '/asistencia/vista-turno', enConstruccion: false },
          { id: 'dashboard-asist', label: 'Dashboard Asistencias', route: '/asistencia/dashboard-asistencias', enConstruccion: false },
          { id: 'asistencia-central', label: 'Asistencia Central', route: '/asistencia/central', enConstruccion: false },
          { id: 'gafetes-biometricos', label: 'Gafetes Biométricos', route: '/asistencia/gafetes-biometricos', enConstruccion: false },
          { id: 'control-accesos', label: 'Control de Accesos', route: '/asistencia/control-accesos', enConstruccion: false },
          { id: 'recorridos', label: 'Escalafón', route: '/empleados/escalafon', enConstruccion: false },
          { id: 'empleados-asist', label: 'Empleados', route: '/asistencia/asistencia-empleado', enConstruccion: false },
          { id: 'cierre-semanal', label: 'Cierre semanal', route: '/nomina/cierre-semanal', enConstruccion: false },
        ]
      },
      {
        id: 'variables',
        label: 'Variables',
        children: [
          { id: 'factores', label: 'Factores', route: '/catalogos/factores', enConstruccion: false },
          { id: 'cat-prima', label: 'Categorias prima de producción', route: '/nomina/prima-produccion', enConstruccion: false },
          { id: 'roles-destajo-azucar', label: 'Roles de Destajo Azúcar', route: '/nomina/roles-destajo-azucar', enConstruccion: false },
          { id: 'conceptos', label: 'Conceptos', route: '/catalogos/conceptos-pago', enConstruccion: false },
          { id: 'captura', label: 'Captura', route: '/nomina/variables-nomina', enConstruccion: false },
          { id: 'seguridad-var', label: 'Seguridad', route: '/variables/permisos-variables', enConstruccion: false },
          { id: 'salario-garantia', label: 'Salario Garantía', route: '/nomina/salario-garantia', enConstruccion: false },
        ]
      },
      {
        id: 'ausentismo',
        label: 'Ausentismo',
        children: [
          { id: 'kardex-aus', label: 'Kardex Ausentismos', route: '/catalogos/detalle-faltas', enConstruccion: false },
          { id: 'pos-cubiertas', label: 'Posiciones cubiertas por día', route: '/asistencia/posiciones-cubiertas', enConstruccion: false },
          { id: 'config-reporte', label: 'Configuración Reporte', route: '/catalogos/config-ausentismo', enConstruccion: false },
          { id: 'reporte-analisis', label: 'Reporte de análisis ausentismo', route: '/asistencia/reporte-analisis-ausentismo', enConstruccion: false },
          { id: 'kardex-mensual', label: 'Kardex Mensual', route: '/asistencia/kardex-mensual', enConstruccion: false },
          { id: 'comp-ausentismo', label: 'Comparativo de Ausentismo', route: '/asistencia/comparativo-ausentismos', enConstruccion: false },
          { id: 'admin-vacacion', label: 'Administración', route: '/asistencia/administracion-ausentismos', enConstruccion: false },
          { id: 'bajas-auto', label: 'Bajas Automáticas', route: '/asistencia/bajas-automaticas', enConstruccion: false },
          { id: 'sua', label: 'Sua', route: '/asistencia/informacion-sua', enConstruccion: false },
        ]
      },
    ]
  },

  // ─────────────────────────────────────────
  //  PROCESOS – Procesos, Reportes, Controles
  // ─────────────────────────────────────────
  {
    id: 'procesos',
    icon: 'ri-settings-3-line',
    label: 'Procesos',
    children: [
      {
        id: 'procesos-menu',
        label: 'Procesos',
        children: [
          { id: 'presencia', label: 'Presencia', route: '/asistencia/presencia', enConstruccion: false },
          { id: 'vales-despensa', label: 'Vales de despensa', route: '/nomina/vales-despensa', enConstruccion: false },
          { id: 'aplica-presencia', label: 'Aplica Presencia', route: '/asistencia/aplicar-presencia', enConstruccion: false },
          { id: 'config-procesos', label: 'Configuracion procesos', route: '/nomina/config-procesos', enConstruccion: false },
          { id: 'procesos-esp', label: 'Procesos de nomina', route: '/nomina/procesos-nomina', enConstruccion: false },
          { id: 'calculo-proc', label: 'Cálculo de Procesos', route: '/nomina/calculo-procesos', enConstruccion: false },
          { id: 'descarga-conceptos', label: 'Descarga de Conceptos', route: '/nomina/descarga-conceptos', enConstruccion: false },
        ]
      },
      {
        id: 'reportes',
        label: 'Reportes',
        children: [
          { id: 'rpt-asistencia', label: 'Asistencia', route: '/procesos/reporte-asistencia', enConstruccion: false },
          { id: 'rpt-plantilla', label: 'Plantilla', route: '/procesos/reporte-plantilla', enConstruccion: false },
          { id: 'rpt-especial', label: 'Especial de asistencia', route: '/procesos/reporte-especial', enConstruccion: false },
          { id: 'jornadas-plantilla', label: 'Jornadas por plantilla', route: '/procesos/jornadas-plantilla', enConstruccion: false },
          { id: 'jornadas-cat', label: 'Jornadas por categoría', route: '/procesos/jornadas-categoria', enConstruccion: false },
          { id: 'comparativo', label: 'Comparativo', route: '/procesos/comparativo-dashboard', enConstruccion: false },
          { id: 'rpt-genericos', label: 'Reportes genéricos', route: '/procesos/reportes-genericos', enConstruccion: false },
        ]
      },
      {
        id: 'reportes-especiales',
        label: 'Reportes especiales',
        children: [
          { id: 'rpt-esp-no-adeudo', label: 'Carta de No Adeudo', route: '/procesos/carta-no-adeudo', enConstruccion: false },
          { id: 'rpt-esp-renuncia', label: 'Carta de Renuncia', route: '/procesos/carta-renuncia', enConstruccion: false },
          { id: 'rpt-esp-requisicion', label: 'Requisición de Personal', route: '/procesos/requisicion-personal', enConstruccion: false },
          { id: 'rpt-esp-contrato', label: 'Contrato de Personal', route: '/procesos/contrato-personal', enConstruccion: false },
          { id: 'rpt-esp-costeo', label: 'Costeo', route: '/procesos/reporte-costeo', enConstruccion: false },
          { id: 'rpt-esp-disenador', label: 'Diseñador de reportes', route: '/procesos/disenador-reportes', enConstruccion: false },
        ]
      },
      {
        id: 'controles',
        label: 'Controles',
        children: [
          { id: 'dash-ppto-extra', label: 'Dashboard presupuesto extra', route: '/controles/dashboard-ppto-extra', enConstruccion: false },
          { id: 'dash-ppto-proy', label: 'Dashboard presupuesto proyectos', route: '/controles/dashboard-ppto-proyectos', enConstruccion: false },
          { id: 'dash-variables', label: 'Dashboard de variables', route: '/controles/dashboard-variables', enConstruccion: false },
          { id: 'dash-variables-dept', label: 'Dashboard de variables por departamento', route: '/controles/dashboard-variables-depto', enConstruccion: false },
          { id: 'control-75', label: 'Control 75%', route: '/procesos/control-75', enConstruccion: false },
          { id: 'ppto-req', label: 'Presupuesto Requisiciones', route: '/procesos/presupuesto-requisiciones', enConstruccion: false },
          { id: 'ppto-var', label: 'Presupuesto Variables', route: '/procesos/presupuesto-variables', enConstruccion: false },
          { id: 'ppto-var-dept', label: 'Presupuesto Variables por departamento', route: '/procesos/variables-departamento', enConstruccion: false },
          { id: 'ppto-tareas', label: 'Presupuesto para tareas', route: '/catalogos/presupuesto-tareas', enConstruccion: false },
          { id: 'ctrl-tareas-div', label: 'Control de tareas por división', route: '/procesos/control-tareas-division', enConstruccion: false },
        ]
      },
    ]
  },

  // ─────────────────────────────────────────
  //  CAPACITACIÓN
  // ─────────────────────────────────────────
  {
    id: 'capacitacion',
    icon: 'ri-graduation-cap-line',
    label: 'Capacitación',
    children: [
      { id: 'capacitacion-dashboard', label: 'Dashboard de Capacitación', route: '/capacitacion/dashboard', enConstruccion: false },
      { id: 'perfiles-puestos', label: 'Perfiles de Puestos', route: '/capacitacion/perfiles-puestos', enConstruccion: false },
      { id: 'capacitaciones', label: 'Capacitaciones', route: '/capacitacion/capacitaciones', enConstruccion: false },
      { id: 'formaciones', label: 'Formaciones', route: '/capacitacion/formaciones', enConstruccion: false },
      { id: 'competencias', label: 'Competencias', route: '/capacitacion/competencias', enConstruccion: false },
      { id: 'experiencias', label: 'Experiencias', route: '/capacitacion/experiencias', enConstruccion: false },
      { id: 'conocimientos', label: 'Conocimientos', route: '/capacitacion/conocimientos', enConstruccion: false },
      { id: 'grados-dominio', label: 'Grados de dominio', route: '/capacitacion/niveles-capacitacion', enConstruccion: false },
      { id: 'habilidades', label: 'Habilidades', route: '/capacitacion/habilidades', enConstruccion: false },
    ]
  },

  // ─────────────────────────────────────────
  //  ADMINISTRACIÓN – Seguridad, Configuración, Contratistas
  // ─────────────────────────────────────────
  {
    id: 'administracion',
    icon: 'ri-lock-line',
    label: 'Administración',
    children: [
      {
        id: 'seguridad',
        label: 'Seguridad',
        children: [
          { id: 'usuario', label: 'Usuarios', route: '/seguridad/usuarios', enConstruccion: false },
          { id: 'rol', label: 'Roles', route: '/catalogos/roles', enConstruccion: false },
          { id: 'permisos-rol', label: 'Permisos por rol', route: '/seguridad/permisos-por-rol', enConstruccion: false },
          { id: 'bitacora', label: 'Bitácora', route: '/seguridad/bitacora', enConstruccion: false },
          { id: 'seg-usuario', label: 'Seguridad de usuarios', route: '/seguridad/seguridad-usuarios', enConstruccion: false },
          { id: 'permisos-plant', label: 'Permisos por plantilla', route: '/seguridad/permisos-plantilla', enConstruccion: false },
          { id: 'directrices', label: 'Directrices de seguridad', route: '/seguridad/directrices-seguridad', enConstruccion: false },
          { id: 'desbloquear', label: 'Desbloquear usuarios', route: '/seguridad/desbloquear-usuarios', enConstruccion: false },
        ]
      },
      {
        id: 'configuracion',
        label: 'Configuración',
        children: [
          { id: 'aplicacion', label: 'Aplicación', route: '/catalogos/config-aplicacion', enConstruccion: false },
          { id: 'api', label: 'API', route: '/catalogos/config-api', enConstruccion: false },
          { id: 'tipos-mov', label: 'Tipos de movimientos', route: '/catalogos/tipos-movimiento', enConstruccion: false },
          { id: 'faltas', label: 'Faltas', route: '/catalogos/faltas', enConstruccion: false },
          { id: 'estructura-ev', label: 'Estructura de Eventuales', route: '/plantilla/estructura-eventuales', enConstruccion: false },
          { id: 'prioridad-conc', label: 'Prioridad Concepto Asistencia', route: '/catalogos/prioridad-conceptos', enConstruccion: false },
          { id: 'fact-prestaciones', label: 'Factores de Prestaciones', route: '/catalogos/factores-prestaciones', enConstruccion: false },
          { id: 'clasificaciones', label: 'Configuración de Clasificación', route: '/catalogos/config-clasificacion', enConstruccion: false },
          { id: 'cfg-correo', label: 'Configuración de correo', route: '/catalogos/config-correo', enConstruccion: false },
          { id: 'org-alterno', label: 'Organigrama Alterno', route: '/organizacion/organigrama-alterno', enConstruccion: false },
          // Vuelve al menú el 04-10-2026 con la guía de integración del API. La opción de
          // permiso sigue siendo la 234; sólo cambió la etiqueta, que antes decía Herramientas.
          { id: 'doc-tecnica', label: 'Documentación técnica', route: '/configuracion/herramientas', enConstruccion: false },
        ]
      },
      {
        id: 'contratistas',
        label: 'Contratistas',
        children: [
          { id: 'emp-contratistas', label: 'Empleados contratistas', route: '/contratistas/empleados-contratistas', enConstruccion: false },
          { id: 'contratistas-lst', label: 'Contratistas', route: '/contratistas/contratistas', enConstruccion: false },
          { id: 'contrato-ot-os', label: 'Contrato / OT / OS', route: '/contratistas/contratos', enConstruccion: false },
          { id: 'proyecto', label: 'Proyectos', route: '/catalogos/proyectos', enConstruccion: false },
        ]
      },
    ]
  },
];
